var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeftLg = function SvgArrowLeftLg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 26,
    fill: "#fff",
    viewBox: "0 0 14 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.483 1.08a1.607 1.607 0 0 1 0 2.272l-9.575 9.575 9.575 9.575a1.607 1.607 0 0 1-2.273 2.272L.499 14.064a1.607 1.607 0 0 1 0-2.274L11.21 1.08a1.607 1.607 0 0 1 2.273 0",
    clipRule: "evenodd"
  })));
};
export default SvgArrowLeftLg;